import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'src/app/interfaces/message';
import { MessageService } from 'src/app/services/api/message.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-open',
    templateUrl: './open.component.html',
    styleUrls: ['./open.component.scss']
})

export class OpenComponent implements OnInit {

    loading$ = this.loader.loading$;

    public ref: string | undefined;
    public message: Message | undefined;

    public errorMessage: string = '' ;
    public errorType: string = '' ;

    constructor(public userService: UserService,
                public route: Router,
                public loader: LoadingService,
                public activeRoute: ActivatedRoute,
                public messageApi: MessageService)
    {}

    ngOnInit(): void {

        this.loader.show("SPINNER-LOADER.OPEN-MESSAGE");

        this.activeRoute.params.subscribe(params => {
            if (params.ref) {
                this.ref = encodeURIComponent(params.ref)
            }
        });

        this.messageApi.open(this.ref!).subscribe((res) => {
            this.loader.hide();
            if (res.result == "SUCCESS") {
                this.message = res.content;
            } else {
                this.errorType = res.result;
                this.errorMessage = res.content;
            }
        }, (err) => {
            this.loader.hide();
        });
    }
}
